import useSWR from 'swr';
import { DeepNullable } from 'ts-essentials';
import fetcher from 'lib/fetcher';
import { APIApartmentRoomType, CoordinatesSchema } from 'api/types';

export type ApartmentFiltersSecondary = {
  buildingIds: number[];
  roomCount?: number[];
  marketType?: string;
  priceFrom: number | undefined;
  priceTo: number | undefined;
  facilityTypeIds?: number[];
  areaFrom: number | undefined;
  areaTo: number | undefined;
};

export type PlansItemType = {
  areaInSqM: number;
  id: number;
  media: { id: number; mimeType: string; name: string; url: string | null };
  selected: boolean | null;
};

export interface IPolygonItemRequest {
  id: number;
  name: string;
  coordinates: {
    latitude: number;
    longitude: number;
  }[];
  color: string;
}

export type APIApartmentFilterLimitsRes = {
  count: number;
  filters: DeepNullable<{
    areaMax: number;
    areaMin: number;
    priceMax: number;
    priceMin: number;
    marketPriceMax: number;
    marketPriceMin: number;
    plans: PlansItemType[];
    polygons: IPolygonItemRequest[];
    buildingAddressSearchPoligons?: CoordinatesSchema[][] | null;
  }> & { facilityTypes: APIApartmentRoomType[]; roomCount?: number[] };
};

const useApartmentsLimitsSecondary = (filter?: ApartmentFiltersSecondary | null, fetch = true) => {
  const { data, error, isLoading } = useSWR(fetch ? [filter] : null, ([filter]) =>
    fetcher
      .swr<APIApartmentFilterLimitsRes>('/facilities/filter-limits', {
        method: 'post',
        data: { filter },
      })
      .then((res) => {
        return res;
      }),
  );

  return { filterLimits: data?.filters, count: data?.count, error, isLoading };
};

export default useApartmentsLimitsSecondary;
